import { FORUM_COMMENTS } from '../ids';
import { InstallLocation } from '../types';
export const ids = FORUM_COMMENTS;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    installLocation: InstallLocation.Profile,
    social: true,
    numbers: {
        key: 'createdCommentsCount',
        default: 0,
    },
    method: 'addSection',
    urlOverride: 'forum-comments',
    menuOrder: 2,
    page: {
        name: t('comments_page_name'),
        shortDescription: t('comments_page_short_description'),
        description: t('comments_page_description'),
        iconURL: `${staticsUrl}assets/images/icons/forum-icon.png`,
        origin: t('forum_origin'),
        screenshots: [
            `${staticsUrl}assets/images/forum-comments/forum-comments.png`,
            `${staticsUrl}assets/images/forum-comments/mobile-forum-comments.png`,
        ],
    },
});
//# sourceMappingURL=forum-comments.js.map